<template>
    <el-form :inline="data.inline" :model="formData" :size="data.size || 'default'" :rules="data.rules"
        :label-position="data.labelPosition || 'left'" v-bind="data.attr" ref="form" @submit.stop.prevent="onSubmit">
        <template v-for="(item, index) in data.options" :key="index">
            <el-form-item :label="item.label" :prop="item.prop">
                <slot :name="item.prop" :item="item" :slot="data" :data="formData">
                    <el-input  v-if="item.type == 'input'" v-model="formData[item.prop]" :type="item.inType || 'text'"
                        :disabled="disabled || !!item.disabled" :placeholder="item.placeholder" :showPassword="item.showPassword"
                        clearable min="0" :style="item.style"  :step="item.step || 'any'" :prefix-icon="item.icon" :maxlength="item.maxLen"
                        :size="item.size || data.size || 'default'">
                        <template v-if="item.prepend" #prepend>
                            {{ item.prepend }}
                        </template>
                    </el-input>
                    <el-input-number v-if="item.type == 'number'" v-model="formData[item.prop]" :min="item.min || 0"
                        :max="item.max || Infinity" :size="item.size || data.size || 'default'" :disabled="disabled || !!item.disabled" />
                    <el-select v-if="item.type == 'select'" v-model="formData[item.prop]"
                        :placeholder="item.placeholder || '请选择'" :style="item.style || { width: '170px' }"
                        :filterable="true" :disabled="disabled || !!item.disabled" :size="item.size || data.size || 'default'"
                        :empty-values="data.emptyValues || [undefined, null]">
                        <el-option v-for="(opt, optIndex) in item.optList" :key="optIndex" :label="opt.label"
                            :value="opt.value">
                        </el-option>
                    </el-select>
                    <el-date-picker v-if="item.type == 'date'" v-model="formData[item.prop]" type="date"
                        :placeholder="item.placeholder || '选择日期'"></el-date-picker>
                    <el-date-picker v-if="item.type == 'daterange'" v-model="formData[item.prop]" type="daterange"
                        :placeholder="item.placeholder || '选择日期范围'" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期"></el-date-picker>
                    <el-switch v-if="item.type == 'switch'" v-model="formData[item.prop]"
                        :size="item.size || data.size || 'default'" :active-text="item.activeText || '是'"
                        :inactive-text="item.inactiveText || '否'" :disabled="disabled || !!item.disabled"></el-switch>
                    <el-radio-group v-if="item.type == 'radio'" v-model="formData[item.prop]">
                        <el-radio v-for="(opt, optIndex) in item.optList" :key="optIndex" :value="opt.value"
                            :disabled="opt.disabled" :size="opt.size || item.size || 'default'"><span
                                v-html="opt.label"></span></el-radio>
                    </el-radio-group>
                    <el-checkbox-group v-if="item.type == 'checkbox'" v-model="formData[item.prop]">
                        <el-checkbox v-for="(opt, optIndex) in item.optList" :key="optIndex" :value="opt.value"
                            :disabled="opt.disabled" :size="opt.size || item.size || 'default'">
                            <span v-html="opt.label"></span>
                        </el-checkbox>
                    </el-checkbox-group>
                    <el-button v-if="item.type == 'button'" type="primary" class="defaultButton" :style="item.style"
                        native-type="submit">
                        {{ item.text || '提交' }}
                    </el-button>
                </slot>
                <div class="itemTip" v-if="item.tip"><i class="fas fa-info-circle"></i>{{ item.tip }}</div>
            </el-form-item>
        </template>
        <el-form-item v-if="data.submitBtn">
            <slot name="submitBtn">
                <div class="btns">
                    <el-button type="primary" class="defaultButton" native-type="submit">
                        提交
                    </el-button>
                </div>
            </slot>
        </el-form-item>

        <slot name="extra"></slot>
    </el-form>
</template>

<script setup lang="ts">
import { onMounted, ref, toRefs } from 'vue';

const props = defineProps({
    data: {
        type: Object,
        default: {},
    },
    formData: {
        type: Object,
        default: () => ref({}),
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const { formData } = toRefs(props);

const defaultMap: any = {
    checkbox: [],
    switch: false,
}
const initFormData = () => {
    props.data.options.forEach((item: any) => {
        if (item.hidden || !item.prop) return;
        const def = defaultMap[item.type] !== undefined ? defaultMap[item.type] : '';
        formData.value[item.prop] =
            formData.value[item.prop] || item[item.prop] || item.default || def;
    });
};
initFormData();
// 事件
const emit = defineEmits(['submit', 'update:modelValue']);
const onSubmit = () => {
    emit('submit', formData);
    return false;
};
// const updateData =

const form = ref('');
const getFormRef = function () {
    return form.value;
};
defineExpose({
    formData,
    getFormRef,
});
onMounted(() => { });
</script>

<style scoped lang="less">
.el-button {
    width: 100%;
}

.el-form-item {
    // margin-bottom: 10px;
}

.itemTip {
    font-size: 14px;
    line-height: 1.6em;
    color: #A8ABB2;
}
</style>
